/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Row, Col } from 'react-bootstrap';
import {
  useForm,
  FieldValues,
  SubmitHandler,
  Controller
} from 'react-hook-form';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';
import { showAlert } from 'store/alert/alert.thunk';
import installmentService from 'service/installment';

interface UpdateInstallemntProps {
  setOpenUpdateInstallment: (show: boolean) => void;
  refetch?: any;
  selectedInstallmentId?: any;
  setSelectedInstallmentId?: any;
}

const UpdateInstallemnt = ({
  setOpenUpdateInstallment,
  refetch,
  selectedInstallmentId,
  setSelectedInstallmentId
}: UpdateInstallemntProps) => {
  const { t } = useTranslation();

  const dispatch: Dispatch<any> = useDispatch();
  const [loading, setLoading] = useState(false);
  const { handleSubmit, reset, control } = useForm();
  const hasFetchedData = useRef(false);
  const inputRef = useRef<HTMLInputElement | any>();

  const options = [
    {
      value: true,
      label: t('active')
    },
    {
      value: false,
      label: t('blocked')
    }
  ];

  //fetch with id
  const fetchData = () => {
    if (selectedInstallmentId === '') return setLoading(false);

    installmentService
      .getInstallmentById(selectedInstallmentId)
      .then((res: any) => {
        const computed = {
          status: res?.status ? res?.status : false
        };
        reset(computed);
      })
      .finally(() => setLoading(false));
  };

  const onSubmit: SubmitHandler<FieldValues> = data => {
    if (selectedInstallmentId !== '') return update(data);
  };

  const update = (data: any) => {
    setLoading(true);

    const updateData = {
      // prettier-ignore
      status:
          data?.status === 'true' || data?.status === true
            ? true
            : data?.status === 'false' || data?.status === false
              ? false
              : false,
      id: selectedInstallmentId
    };
    installmentService
      .updateInstallment(selectedInstallmentId, updateData)
      .then((res: any) => {
        if (res) {
          dispatch(
            showAlert({
              title: `${t('products')} ${t('successfully_added')}`,
              type: 'success'
            })
          );
          refetch();
          setLoading(false);
          setOpenUpdateInstallment(false);
          setSelectedInstallmentId(0);
        }
      });
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef.current]);

  useEffect(() => {
    if (selectedInstallmentId !== '' && !hasFetchedData.current) {
      fetchData();
      hasFetchedData.current = true;
    }
  }, [selectedInstallmentId]);

  return (
    <>
      <Form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <Row className="mb-3">
          <Col>
            <div className="react-select-container">
              <Controller
                name="status"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Form.Floating>
                    <Form.Select {...field}>
                      <option className="d-none" value=""></option>
                      {options?.map((option: any) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>

                    <label htmlFor="floatingInputCustom">{t('status')}</label>
                  </Form.Floating>
                )}
              />
            </div>
          </Col>
        </Row>

        <Button
          style={{ height: '48px', marginTop: 'auto' }}
          variant="primary"
          type="submit"
          loading={loading}
        >
          {t('add')}
        </Button>
      </Form>
    </>
  );
};

export default UpdateInstallemnt;
